import { render, staticRenderFns } from "./BathIcon.vue?vue&type=template&id=642ae2d5&"
import script from "./BathIcon.vue?vue&type=script&lang=js&"
export * from "./BathIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports